(function(d) {
  var s = d.createElement("script"); 
  s.type = "text/javascript"; 
  s.charset = "utf-8";
  s.defer = true;
  s.src = ("https:" == d.location.protocol ? "https://" : "http://") + "checkout-api.worldshopping.jp/v1/script?token=store_tomorrowland_co_jp";
  var s1 = d.getElementsByTagName("script");
  var s2 = s1[s1.length - 1]
  s2.parentNode.insertBefore(s, s2);
})(document);

jQuery(function ($) { 
    var topBtn = $('.button-to-top');
    if ($('.to-top_3').length > 0) return false;
    // topBtn.hide();
    $(window).scroll(function () {
        if (jQuery(this).scrollTop() > 1000) {
          // 指定px以上のスクロールでボタンを表示
          topBtn.fadeIn();
        } else {
          // 画面が指定pxより上ならボタンを非表示
          topBtn.fadeOut();
        }
      });
    
      // ボタンをクリックしたらスクロールして上に戻る
      topBtn.on('click', function (e) {
        e.preventDefault();
        $(window).scrollTop(0);
      })

    jQuery(window).on("scroll", function() {
      // トップから100px以上スクロールしたら
      if (jQuery(this).scrollTop()) {
        // is-showクラスをつける
     jQuery('.button-to-top').addClass( 'show' );
      } else {
        // 100pxを下回ったらis-showクラスを削除
      jQuery('.button-to-top').removeClass( 'show' );
      }
  });
});

$(function () {
    $(document).on("click", '.modal_error_close, .cart_modal_bg, .modal.modal_error', function () {
      $('#modal_error').css('display', 'none');
      $('#cart_modal_error').css('display', 'none');
      $('#modal_error').fadeOut();
      $('body').css({"padding-right": "0px"});
      $(".cart_modal_bg").fadeOut("slow", function () {
        $(".cart_modal_bg").remove();
        $('body').removeClass('lock_scroll');
    });
    });
});

const getSHA256Hash = async (input) => {
    const textAsBuffer = new TextEncoder().encode(input);
    const hashBuffer = await window.crypto.subtle.digest("SHA-256", textAsBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hash = hashArray
      .map((item) => item.toString(16).padStart(2, "0"))
      .join("");
    return hash;
};

module.exports.getSHA256Hash = getSHA256Hash;



